const Accordion = () => {
    var acc = document.getElementsByClassName("accordion--opener");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            } 
        });
    }
}

const FAQs = () => {
    const widget = document.querySelector('.faq--container');
    let items = widget?.querySelectorAll('.faq--item');

    console.log(widget);

    items?.forEach(item => {
        let button = item.querySelector('.faq--button');

        button.addEventListener("click", function () {
            console.log (item);
            items.forEach(e => {
                if (e != item)
                    e.classList.remove("active");
            });

            item.classList.toggle("active");
        });
    });
}

const Tab = (widget) => {
    let buttons = widget.querySelectorAll('.tab_button--group button');
    let cards = widget.querySelectorAll('.tab_content .cw_gird--card');

    buttons?.forEach(button => {
        button.addEventListener("click", function () {
            cards.forEach(card => {
                if (card.classList.contains(`${this.dataset.target}`)) {
                    card.classList.add("active");
                } else {
                    card.classList.remove("active");
                }
                
            });
            this.parentNode.querySelectorAll("button").forEach(button => button.classList.remove("active"));
            this.classList.add("active");
        });
    });
}

const setCasualTarget = (select) => {
    select.addEventListener('change', function () {
        let option = this.options[this.selectedIndex];
        let casualLink = document.querySelector('.casual--link');

        casualLink.setAttribute('href', option.dataset.target);
    })
}

const cwTrainerProfile = (wrapper) => {
    var truncatedCards = wrapper.querySelectorAll('.trainer-card.truncated');
    truncatedCards?.forEach(card => {
        if (window.innerWidth > 751) {
            card.addEventListener("mouseover", function () {
                this.classList.remove("truncated");
            });
            card.addEventListener("mouseout", function () {
                this.classList.add("truncated");
            });
        } else {
            card.addEventListener("click", function () {
                this.classList.toggle("truncated");
            });
        }
    })
}

(function () {
    let TabWrappers = document.querySelectorAll(".tab--wrapper");
    TabWrappers?.forEach(wrapper => {
        Tab(wrapper);
    });

    let cwTrainerProfiles = document.querySelectorAll('.cw-trainer-profiles');
    cwTrainerProfiles?.forEach(wrapper => {
        cwTrainerProfile(wrapper);
    });

    let casualSelect = document.querySelectorAll('.casual-select').forEach((select) => {
        setCasualTarget(select);
    });

    Accordion();
    FAQs();
})();